import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import { useTranslation } from 'react-i18next'
import { getUrlQuery } from '../actions/UserAction'
import { PHASE_START, setShowPhase } from '../actions/recommendationAction'
import { useDispatch } from 'react-redux'
import { COLORS } from '../common/Colors'

const { BLUE } = COLORS;

const Container: any = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 80vh;
    .MuiButton-containedPrimary {
        width: 430px;
        height: 45px;
        margin-top: 30px;
        font-weight: bold;
        border-radius: 10px;
        font-weight: 700;
        @media(max-width: 600px) {
            font-size: 13px;
            width: 80%;
        }
    }
    
    .MuiGrid-justify-content-xs-center {
        margin-top: 30px;
        margin-bottom: 20px;
    }
   
    @media(max-width: 600px) {
        width: 100%;
    }
    .MuiButton-outlinedPrimary {
        color: ${BLUE};
        border: 2px solid ${BLUE};
        font-size: 18px;
        font-weight: bold;
    }
    .btn-outlined {
        margin-top: 150px;
    }
`




const Landing = (props: any) => {
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const search = (location.search).replace('?', '');
    // const { user } = useContext(FirebaseContext);
    // const url = new URL(window.location.href);
    // const UPC: any = url.searchParams.get('UPC') || url.searchParams.get('upc');
    // const productId: any = url.searchParams.get('productId');

    useEffect(() => {
        i18n.changeLanguage(i18n.language)
        // eslint-disable-next-line
    }, [i18n.language])

    // const { sizeChart, recommendations } = useSelector((state: any) => state.recommendationReducer);

    const openRecommendation = () => {
        const url = getUrlQuery();
        if (url) {
            navigate(`/measurement${url}`);
        } else {
            navigate(`/measurement?apikey=${process.env.REACT_APP_API_KEY}`) // &measureOnly=false
        }
        dispatch(setShowPhase(PHASE_START));
    }

    return (
        <Container >
            {/* {!recommendations && (UPC || productId) && <SizeChartInformation />} */}
            {
            // (!user && (!sizeChart || (sizeChart && sizeChart.isNotSizeChart))) &&
             <>
                <Button type='submit' variant='contained' color='primary' onClick={() => window.location.href = `${process.env.REACT_APP_LOGIN_URL}&${search}&path=${location.pathname}`}>
                    {t('sign_to_my_sizey')}
                </Button>
                <Button type='submit' variant='contained' color='primary'
                    onClick={openRecommendation}
                >
                    {t('make_new_measuring')}
                </Button>
                <Grid container justifyContent='center'>
                    <Grid item>
                        <Link className='sign-up-link' to='' onClick={() => window.location.href = `${process.env.REACT_APP_REGISTER_URL}&${search}&path=${location.pathname}`} >
                            {t(`sign_up_to_my_sizey`)}
                        </Link>
                    </Grid>
                </Grid>
            </>}
        </Container>
    )
}

export default Landing;
